import * as React from 'react';
import * as Highcharts from 'highcharts';
import {Card, CardContent} from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import {getDefaultPieFormatting} from '../../charts/pie';

interface IPermanentProps {
    final: any[];
}

const Permanent = ({final}: IPermanentProps) => {
    const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = React.useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        const permanent = final
            .map((submission: any) => Number(submission.type_contract_t1_per_contract_t1))
            .filter(value => !Number.isNaN(value))
            .reduce((a, b) => a + b, 0);

        const total = final
            .map((submission: any) => Number(submission.jobs_t1_men_t1_number) + Number(submission.jobs_t1_women_t1_number))
            .reduce((a, b) => a + b, 0);

        const data = [
            {
                name: 'Permanent Job',
                y: permanent,
            },
            {
                name: 'Other',
                y: total - permanent,
            },
        ];

        const title = '% of permanent job positions';
        const dashboardOptions: any = getDefaultPieFormatting(title, data);
        setOptions(dashboardOptions);
    };

    React.useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className='chart-container'>
            <CardContent>
                {options && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        ref={chartComponentRef}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default Permanent;
